import { render, staticRenderFns } from "./CreateEditPublication.vue?vue&type=template&id=289bb295"
import script from "./CreateEditPublication.vue?vue&type=script&lang=js"
export * from "./CreateEditPublication.vue?vue&type=script&lang=js"
import style0 from "./CreateEditPublication.vue?vue&type=style&index=0&id=289bb295&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports